import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import DatePicker from "react-datepicker";
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { loadCountryNameDropdownData, loadLeaveBalanceData, loadLeavesBalanceCount, loadSettingsLeavePolicyData, loadUserDropdownData, postLeaveBalanceDatas } from "../../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication'
import { ADDED_BY_ID } from "../../Constants";
import moment from "moment";

const AddLeave = (props) => {
    let dispatch = useDispatch();
    const leaveBalanceUserId = props.leaveBalanceUserId;
    const singleLeaveBalanceData = props.singleLeaveBalanceData;
    const { getUserDropdown } = useSelector((state) => state.data);
    const { getLeavePolicyData } = useSelector((state) => state.data);
    const { leaveBalanceData = [] } = useSelector((state) => state.data);
    const { leaveBalanceCount = [] } = useSelector((state) => state.data);

    const { getCountryNameDropdown } = useSelector((state) => state.data);
    // State to store selected user's role and department
    const [role, setRole] = useState('');
    const [department, setDepartment] = useState('');
    const [countryCodeID, setCountryCodeID] = useState('');
    const [leaveData, setLeaveData] = useState({});
    const [filteredLeavePolicies, setFilteredLeavePolicies] = useState([]);
    const [userId, setUserId] = useState();
    const [loading, setLoading] = useState(false);
    const [leaveTypeId, setLeaveTypeId] = useState();

    // State for dates
    const [fromDate, setFromDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState('');

    const [userError, setUserError] = useState("");
    const [fromDateError, setFromDateError] = useState("");
    const [toDateError, setToDateError] = useState("");
    const [policyError, setPolicyError] = useState('');

    // State for leave balance data
    const [leaveBalance, setLeaveBalance] = useState({
        daysAllotted: '',
        daysAvailed: '',
        daysAvailable: '',
    });

    useEffect(() => {
        dispatch(loadUserDropdownData());
        dispatch(loadCountryNameDropdownData());
    }, []);

    // Inside your component, when the country code is set
    useEffect(() => {
        if (countryCodeID) {
            dispatch(loadSettingsLeavePolicyData(countryCodeID)); // Pass the selected country code
        }
    }, [countryCodeID, dispatch]);

    useEffect(() => {
        if (getLeavePolicyData && countryCodeID) {
            const countryObj = getCountryNameDropdown.find(country => country.CountryCodeID === countryCodeID);
            const countryName = countryObj ? countryObj.label : '';

            // ✅ Filter policies for the selected country
            const policies = getLeavePolicyData.filter(policy => policy.Country === countryName && policy.StatusID !== 31);
            setFilteredLeavePolicies(policies);
        } else {
            setFilteredLeavePolicies([]); // ✅ Prevent undefined errors
        }
    }, [getLeavePolicyData, countryCodeID, getCountryNameDropdown]);

    useEffect(() => {
        if (userId && filteredLeavePolicies) {
            if (filteredLeavePolicies.length === 0) {
                setPolicyError("No leave policies available for the selected user.");
            } else {
                setPolicyError(""); // ✅ Clear error if policies exist
            }
        }
    }, [userId, filteredLeavePolicies]);
    console.log(filteredLeavePolicies, 'filteredLeavePolicies')

    useEffect(() => {
        // Check if leaveBalanceData exists and contains valid data for the selected userId
        if (leaveBalanceData && leaveBalanceData.length > 0) {
            const selectedUserBalance = leaveBalanceData.find(data => data.UserID === userId);

            if (selectedUserBalance && selectedUserBalance.LeaveBalanceDays && selectedUserBalance.LeaveBalanceDays.length > 0) {
                const leaveBalanceInfo = selectedUserBalance.LeaveBalanceDays[0];  // Assuming one leave balance object per user
                setLeaveBalance({
                    daysAllotted: leaveBalanceInfo.NoofDaysAllotted,
                    daysAvailed: leaveBalanceInfo.NoofDaysAvailed,
                    daysAvailable: leaveBalanceInfo.NoofDaysAvailable,
                });
            } else {
                // If no leave balance data exists for the user, set default values (e.g., 0)
                setLeaveBalance({
                    daysAllotted: 0,
                    daysAvailed: 0,
                    daysAvailable: 0,
                });
            }
        } else {
            // If no leave balance data exists for any user, set default values
            setLeaveBalance({
                daysAllotted: 0,
                daysAvailed: 0,
                daysAvailable: 0,
            });
        }
    }, [leaveBalanceData, userId]);

    // Handler when a user is selected from the dropdown
    const handleUserSelect = (selectedOption) => {
        setUserId(selectedOption.value)
        const selectedUser = getUserDropdown.find((user) => user.value === selectedOption.value);
        if (selectedUser) {
            setRole(selectedUser.role);
            setDepartment(selectedUser.department);
            setCountryCodeID(selectedUser.CountryCodeID);
        }
        if (userError) setUserError("");
        // dispatch(loadLeaveBalanceData(setLoading, selectedOption.value));
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
        if (fromDateError) setFromDateError("");
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        if (toDateError) setToDateError("");
    };

    useEffect(() => {
        if (userId && fromDate && endDate) {
            // Format the dates using moment to 'YYYY-MM-DD' format
            const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
            const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

            // Dispatch the action with formatted dates
            dispatch(loadLeavesBalanceCount(setLoading, userId, formattedFromDate, formattedEndDate));
        }
    }, [userId, fromDate, endDate, dispatch]);


    const handleLeaveDataChange = (e, policyID) => {
        const allottedDays = parseInt(e.target.value) || 0;

        setLeaveData((prevLeaveData) => ({
            ...prevLeaveData,
            [policyID]: {
                NoofDaysAllotted: allottedDays,
                NoofDaysAvailed: 0, // Always set to 0
                NoofDaysAvailable: allottedDays, // Matches NoofDaysAllotted
            },
        }));
        // Clear the error when the user starts typing
        if (error) setError("");
    };

    useEffect(() => {
        if (singleLeaveBalanceData && singleLeaveBalanceData.length > 0 && leaveBalanceUserId) {
            // Find the selected user's leave balance data
            const selectedUserBalance = singleLeaveBalanceData.find(data => data.UserID === leaveBalanceUserId);

            if (selectedUserBalance) {
                // Find the selected user details from the dropdown
                const selectedUser = getUserDropdown.find((user) => user.value === leaveBalanceUserId);
                console.log('Selected User:', selectedUser);

                if (selectedUser) {
                    setCountryCodeID(selectedUser.CountryCodeID || '');
                    setRole(selectedUser.role || '');
                    setDepartment(selectedUser.department || '');
                } else {
                    // Reset if no user found
                    setCountryCodeID('');
                    setRole('');
                    setDepartment('');
                }

                console.log('Selected User Balance:', selectedUserBalance);
                setUserId(selectedUserBalance.UserID);
                setFromDate(selectedUserBalance.StartDate || '');
                setEndDate(selectedUserBalance.EndDate || '');

                // Process leave balance data
                const leaveBalanceInfo = selectedUserBalance.LeaveBalanceDays.reduce((acc, policy) => {
                    acc[policy.LeaveTypeID] = {
                        NoofDaysAllotted: policy.NoofDaysAllotted,
                        NoofDaysAvailed: policy.NoofDaysAvailed,
                        NoofDaysAvailable: policy.NoofDaysAvailable,
                    };
                    return acc;
                }, {});

                console.log('Leave Balance Info:', leaveBalanceInfo);
                setLeaveData((prevLeaveData) => ({
                    ...prevLeaveData,
                    ...leaveBalanceInfo, // Merge leave balance data for each policy
                }));

                setLeaveTypeId(selectedUserBalance.LeaveBalanceID);

                // Filtering leave policies based on CountryCodeID
                if (getLeavePolicyData && (selectedUser?.CountryCodeID || selectedUserBalance.CountryCodeID)) {
                    const countryID = selectedUser?.CountryCodeID || selectedUserBalance.CountryCodeID;
                    const countryObj = getCountryNameDropdown.find(
                        (country) => country.CountryCodeID === countryID
                    );
                    const countryName = countryObj ? countryObj.label : '';

                    console.log('Country Object:', countryObj);
                    console.log('Country Name:', countryName);

                    const filteredPolicies = getLeavePolicyData.filter(
                        (policy) => policy.Country === countryName && policy.StatusID !== 31
                    );
                    console.log('Filtered Policies:', filteredPolicies);

                    setFilteredLeavePolicies(filteredPolicies); // Store filtered leave policies
                } else {
                    setFilteredLeavePolicies([]); // Reset if no matching policies
                }
            } else {
                // Reset if no user balance is found
                console.log('No user balance found');
                setRole('');
                setDepartment('');
                setCountryCodeID('');
                setUserId('');
                setFromDate('');
                setEndDate('');
                setLeaveData({});
                setLeaveBalance({
                    daysAllotted: 0,
                    daysAvailed: 0,
                    daysAvailable: 0,
                });
                setFilteredLeavePolicies([]); // Reset filtered policies
            }
        }
    }, [singleLeaveBalanceData, leaveBalanceUserId, getLeavePolicyData, getCountryNameDropdown, getUserDropdown]);

    const AddLeaveBalanceData = (e) => {
        e.preventDefault();

        let hasError = false;

        // Validate User Name
        if (!userId) {
            setUserError("User Name is required.");
            hasError = true;
        } else {
            setUserError("");
        }

        // Validate From Date
        if (!fromDate) {
            setFromDateError("From Date is required.");
            hasError = true;
        } else {
            setFromDateError("");
        }

        // Validate To Date
        if (!endDate) {
            setToDateError("To Date is required.");
            hasError = true;
        } else {
            setToDateError("");
        }

        // Stop submission if any error exists
        if (hasError) return;

        // Prepare LeaveBalanceDays data
        const formattedLeaveBalanceDays = filteredLeavePolicies.map((policy) => ({
            LeaveBalanceID: singleLeaveBalanceData[0]?.LeaveBalanceID,
            LeaveTypeID: policy.PolicyID, // Use PolicyID as LeaveTypeID
            NoofDaysAllotted: leaveData[policy.PolicyID]?.NoofDaysAllotted || 0,
            NoofDaysAvailed: 0, // Always send 0
            NoofDaysAvailable: leaveData[policy.PolicyID]?.NoofDaysAvailable || 0, // Matches NoofDaysAllotted
        }));

        // Prepare the full request payload
        const data = {
            LeaveBalanceID: singleLeaveBalanceData[0]?.LeaveBalanceID,
            UserID: userId,
            StartDate: moment(fromDate).format('YYYY-MM-DD'),
            EndDate: moment(endDate).format('YYYY-MM-DD'),
            LeaveBalanceDays: formattedLeaveBalanceDays,
            AddedByID: ADDED_BY_ID,
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action
        dispatch(postLeaveBalanceDatas(requestOption, props.handleCloseAddLeave, leaveBalanceUserId, props.getLeaveBalanceData, setError));
        console.log(data, 'Submitted Data');
    };

    return (
        <>
            <Modal show={props.openAddLeave} onHide={props.handleCloseAddLeave} className='add-customer-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{leaveBalanceUserId ? "Edit Leaves" : "Add Leaves"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>User Name</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Select"
                                            options={getUserDropdown}
                                            // onChange={handleUserSelect}
                                            value={getUserDropdown.find(user => user.value === userId)}
                                            onChange={(selectedOption) => handleUserSelect(selectedOption)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {userError && <div className="text-danger">{userError}</div>}
                                </Col>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>From Date</label>
                                        {/* <div className='add-customer-calendar-container'> */}
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText='Start Date'
                                            selected={fromDate}
                                            onChange={handleFromDateChange}
                                            // maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                        {/* </div> */}
                                    </div>
                                    {fromDateError && <div className="text-danger">{fromDateError}</div>}
                                </Col>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>To Date</label>
                                        {/* <div className='add-customer-calendar-container'> */}
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText='End Date'
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            // minDate={new Date()}
                                            minDate={fromDate || new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                        {/* </div> */}
                                    </div>
                                    {toDateError && <div className="text-danger">{toDateError}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {/* <Col md={4}>
                                    <div>
                                        <label>ID</label>
                                        <Form.Control type="text" value={leaveTypeId} onChange={(e) => { setLeaveTypeId(e.target.value) }} />
                                    </div>
                                </Col> */}
                                <Col md={4}>
                                    <div>
                                        <label>Role</label>
                                        <Form.Control type="text" value={role} disabled />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Department</label>
                                        <Form.Control type="text" value={department} disabled />
                                    </div>
                                </Col>
                            </Row>
                            {/* {filteredLeavePolicies.length > 0 ? (
                                <Row>
                                    {filteredLeavePolicies.map((policy) => (
                                        <Col md={4} key={policy.PolicyID}>
                                            <div>
                                                <label>{policy.LeaveTypeName}</label>
                                                <Form.Control
                                                    type="text"
                                                    value={leaveData[policy.PolicyID]?.NoofDaysAllotted || ''}
                                                    onChange={(e) => handleLeaveDataChange(e, policy.PolicyID)}
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                    {error && <div className="text-danger pt-2 fs-6">{error}</div>}
                                </Row>
                            ) : (
                                policyError && <div className="text-danger pt-2 fs-6">{policyError}</div>
                            )} */}

                            {filteredLeavePolicies.length > 0 ? (
                                <Row>
                                    {filteredLeavePolicies.map((policy) => {
                                        // Find the matching balance data by LeaveTypeName
                                        const matchedBalance = leaveBalanceCount.find(
                                            (item) => item.LeaveTypeName === policy.LeaveTypeName
                                        );

                                        return (
                                            <Col md={4} key={policy.PolicyID}>
                                                <div>
                                                    <label className="fw-semibold">{policy.LeaveTypeName}</label>
                                                    <Form.Control
                                                        type="text"
                                                        value={leaveData[policy.PolicyID]?.NoofDaysAllotted || ''}
                                                        onChange={(e) => handleLeaveDataChange(e, policy.PolicyID)}
                                                    />
                                                    {matchedBalance ? (
                                                        <p className="mb-0 mt-2">
                                                            <span>Carry Forward Days:</span> {matchedBalance.NoofDaysCarryForward}
                                                        </p>
                                                    ) : (
                                                        <p className="text-muted mt-2">No Carry Forward available.</p>
                                                    )}
                                                </div>
                                            </Col>
                                        );
                                    })}
                                    {error && <div className="text-danger pt-2 fs-6">{error}</div>}
                                </Row>
                            ) : (
                                policyError && <div className="text-danger pt-2 fs-6">{policyError}</div>
                            )}

                        </Col>
                    </Row>
                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseAddLeave} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddLeaveBalanceData} />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default AddLeave;